export default __webpack_public_path__ + "logo.64710b3f.png";